module.exports = __webpack_public_path__ + "img/age01.8aca13e7.jpg";